import { BookingStatus } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { coercedBoolean, optionalStringArray, pageParam, pageSizeParam } from '../_shared/coerce.js';
export const getBookingsQuerySchema = z.object({
    clientId: z.string().optional(),
    agency: z.enum(['ALL', 'MRS', 'RUN']).optional(),
    airlineIataCodes: optionalStringArray(),
    page: pageParam(),
    pageSize: pageSizeParam(),
    pendingInsurance: coercedBoolean(),
    search: z.string().optional(),
    sortBy: z.enum(['createdAt', 'departureDate', 'depositDeadline', 'returnDate']).optional(),
    sortOrder: z.enum(['asc', 'desc']).optional(),
    status: z.nativeEnum(BookingStatus).optional(),
    /** true : seulement les dossiers neutres ; false : sans eux ; absent : tous. */
    untracked: coercedBoolean(),
});
